// extracted by mini-css-extract-plugin
export var miniNav = "breadcrumb-module--miniNav--4e550";